import KidSchedule from '../components/KidSchedule';

const Kids = () => (
  <div>
    <KidSchedule />
  </div>
);

export default Kids;
